var exports = {
  "Dk": "xe564cbfb--11644b--carousel",
  "lv": "xe564cbfb--11644b--has-thumbnails",
  "nz": "xe564cbfb--11644b--carousel-left_arrow",
  "gc": "xe564cbfb--11644b--carousel-right_arrow",
  "$Y": "xe564cbfb--11644b--carousel-left_arrow--disabled",
  "_q": "xe564cbfb--11644b--carousel-right_arrow--disabled",
  "nK": "xe564cbfb--11644b--carousel-icon",
  "av": "xe564cbfb--11644b--carousel-counter",
  "f0": "xe564cbfb--11644b--carousel-slide",
  "Ce": "xe564cbfb--11644b--carousel-slide--left",
  "Ai": "xe564cbfb--11644b--carousel-slide--current",
  "PJ": "xe564cbfb--11644b--carousel-slide--right",
  "bF": "xe564cbfb--11644b--carousel-slide--hide",
  "In": "xe564cbfb--11644b--carousel--promo",
};

module.exports = exports;
